const getS3BaseURL = () => {
  const bucketName = String(process.env.REACT_APP_AWS_S3_BUCKET_NAME || '');
  const baseURL = `https://${bucketName}.s3.us-west-2.amazonaws.com/`;
  return baseURL;
};

export default getS3BaseURL;
